<template>
  <div>
    <div class="router" v-loading="loding" v-if="list != null">
      <!-- 上半部分盒子 -->
      <div class="card_top">
        <!-- 左侧图片 -->
        <div class="card_img" @click="apply()">
          <img :src="list.imgurl==null?'https://fview.5kjs.com/style/camp/banner/camp_img.jpg':list.imgurl" @error="
            list.imgurl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          "  alt="" />
        </div>
        <!-- 右侧文字区域 -->
        <div class="card_text_box">
          <!-- 标题 -->
          <div>
            <p class="card_title" @click="apply()">{{ list.name }}</p>
          </div>
          <!-- 详情 -->
          <div class="card_content_box">
            <p class="card_content">
              {{ list.brief_desc }}
            </p>
          </div>
          <!-- 时间等其他信息 -->
          <div class="card_info">
            <div class="card_info_left">
              <p class="card_info_font">
                报名截止：<span class="colorOrange">{{
                  list.sign_end_date
                }}</span>
              </p>
              <p class="card_info_font">
                开营周期：{{ list.begin_date }}~{{ list.end_date }}
              </p>
              <p class="card_info_font">签约人数：{{ list.users_count }}</p>
            </div>
            <div class="card_info_right">
              <p class="card_info_font">
                距离报名截止：<span class="colorOrange">
                  <downTime :endTime="list.sign_end_date"></downTime>
                </span>
              </p>
              <p class="card_info_font">
                契约天数：<span class="colorOrange">{{ list.days_num }}</span>
              </p>
              <p class="card_info_font">
                打卡方式：{{ list.sign_type }}
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content">
                    <p style="padding: 3px 0">
                      天数打卡：必须每天按时完成打卡任务。
                    </p>
                    <p>作业打卡：在报名后规定时间内完成所有打卡。</p>
                  </div>
                  <i class="iconfont icon-wenhao"></i>
                </el-tooltip>
              </p>
            </div>
          </div>
          <!-- 报名按钮 -->
          <div class="apply">
            <div>
              <p class="apply_font">
                已有：<span class="colorOrange">{{ list.users_count }}</span>
                人签订契约
              </p>
              <p class="apply_font">
                <span style="font-weight: bold;f">签约保障金</span>
                <span v-if="false">（完成任务全额返还）</span> ：<span class="colorOrange">￥</span
                ><span class="colorOrange fontSize20">{{ list.price }}</span>
              </p>
            </div>
            <div class="applyBtn">
              <a href="javascript:;" @click="apply()">
                <div class="applyBtn_now">立即报名</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 下半部分盒子 -->
      <div
        class="card_bottom"
        v-if="list.apply_log != null"
        @click="Logapply()"
      >
        <div class="card_bottom_left">
          <div ref="leftLog" class="zore">
            <a
              href="javascript:;"
              class="card_bottom_a"
              v-for="(item, index) in list.apply_log"
              :key="index"
            >
              <div>
                {{ item.created_at }}
                {{ item.username }} 参加了21天打卡
                {{ item.camp_name }}
                <!-- <span class="colorOrange">（{{ item.phase }}）</span> -->
              </div>
            </a>
          </div>
        </div>
        <div class="card_bottom_center"></div>
        <div class="card_bottom_right">
          <div ref="rightLog" class="zore">
            <a
              href="javascript:;"
              class="card_bottom_a"
              v-for="(item, index) in rightLogList"
              :key="index"
            >
              <div>
                {{ item.created_at }}
                {{ item.username }} 参加了21天打卡
                {{ item.camp_name }}
                <!-- <span class="colorOrange">（{{ item.phase }}）</span> -->
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <div v-if="list == null" style="width: 100%; height: 25rem">
      <div
        style="margin: auto; width: 18rem; height: 18rem; text-align: center"
      >
        <img
          style="width: 90%; height: 90%"
          src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
          alt=""
        />
        <div style="color: #333333">暂时没有数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions} from "vuex";
import downTime from "@/components/downTime.vue";
export default {
  components: {
    downTime,
  },
  data() {
    return {
      // 模拟数据
      i: 0,
      list: {
        agency_id: 281,
        apply_log: [
          {
            created_at: "",
            username: "",
            camp_name: "",
            phase: "",
          },
        ],
        0: {
          created_at: "",
          username: "",
          camp_name: "",
          phase: "",
        },
        begin_date: "",
        brief_desc: "",
        camp_id: 1,
        completion_num: 0,
        completion_rate: 0,
        created_at: "",
        days_num: 4,
        desc: "",
        end_date: "",
        exam_id: 116,
        imgurl: "",
        is_end: 0,
        kefu_id: 3,
        limit_num: 12,
        name: "",
        phase: 1,
        price: "",
        sale_price: "",
        sign_end_date: "",
        sign_type: "",
        teacher_id: 234,
        updated_at: "",
        users_count: 3,
        uuid: "",
      },
      // 训练营ID
      camp_id: "",
      // 加载框
      loding: false,
      // 用户购买日志数据模拟
      testlist: [
        {
          camp_name: "",
          created_at: "",
          phase: "",
          username: "",
        },
        {
          camp_name: "",
          created_at: "",
          phase: "",
          username: "",
        },
        {
          camp_name: "",
          created_at: "",
          phase: "",
          username: "",
        },
        {
          camp_name: "",
          created_at: "",
          phase: "",
          username: "",
        },
      ],
      // 左侧轮播图下标
      leftSwarpNum: 0,
      // 右侧轮播图下表
      rightSwarpNum: 0,
      // 右侧用户购买日志数组
      rightLogList: [],
    };
  },
  computed: {
    // ...mapState(["token", "agency_id"]),
     agency_id(){
      if(localStorage.getItem("agency_id")){
        return localStorage.getItem("agency_id")
      }else{
        return 281
      }
    },
     token(){
      if(localStorage.getItem("token")){
        return localStorage.getItem("token")
      }else{
        return null
      }
    },
    _camp_id() {
      return this.$route.params;
    },
  },
  watch: {
    _camp_id(newVal) {
      this.camp_id = newVal.id;
      this.getCamp(this.camp_id);
    },
    agency_id(val) {
      // 请求数据
      this.getCamp(this.camp_id);
      return val;
    },
  },
  methods: {
    ...mapActions(["asyncScrollToTop", "ifLogin"]),
    async apply() {
      this.$router.push("/Detail/apply/" + this.list.camp_id);
      this.asyncScrollToTop();
    },
    // 利用科目ID 请求列表的数据
    getCamp(id) {
      // 请求开始增加Lading事件
      sessionStorage.setItem("router", id);
      this.loding = true;
      this.$axios
        .get("/getCamp", {
          params: {
            // token: this.token,
            agency_id: this.agency_id,
            camp_id: id,
          },
        })
        .then((doc) => {
          if (doc == null) {
            this.loding = false;
            this.list = doc;
          } else {
            // 如果用户当前请求的路由不存在则跳转回主页
            if (doc.code == 201) {
              this.$router.push({ path: "/" });
            }
            this.list = doc;
            // 倒叙处理用户报名日志
            if (doc.apply_log != null) {
              // 如果有用户报名日志则运行轮播
              let tempArr = [...doc.apply_log];

              this.rightLogList = tempArr.reverse();
            }
            this.loding = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击用户购买日志跳转
    Logapply() {
      let camp_id = this.$route.params.id;
      this.$router.push({ path: `/Detail/apply/${camp_id}` });
      this.asyncScrollToTop();
    },
    // 用户购买日志的轮播图事件
    logSwapr() {
      var that = this;
      setInterval(() => {
        if (that.$refs.leftLog) {
          if (this.list.apply_log != null) {
            let val = -3.2125 * this.leftSwarpNum;
            that.$refs.leftLog.style.transition = "all 0.3s ease";
            that.$refs.leftLog.style.transform = `translateY(${val}rem)`;
            if (this.leftSwarpNum < this.list.apply_log.length) {
              this.leftSwarpNum++;
            } else {
              this.leftSwarpNum = 1;
              // that.$refs.leftLog.style.transition = "none";
              that.$refs.leftLog.style.transform = `translateY(0rem)`;
            }
          }
        }
      }, 1500);
      setInterval(() => {
        if (that.$refs.rightLog) {
          if (this.list.apply_log != null) {
            let val = -3.2125 * this.rightSwarpNum;
            that.$refs.rightLog.style.transition = "all 0.3s ease";
            that.$refs.rightLog.style.transform = `translateY(${val}rem)`;
            if (this.rightSwarpNum < this.list.apply_log.length) {
              this.rightSwarpNum++;
            } else {
              this.rightSwarpNum = 1;
              // that.$refs.leftLog.style.transition = "none";
              that.$refs.rightLog.style.transform = `translateY(0rem)`;
            }
          }
        }
      }, 1500);
    },
  },
  mounted() {
    // 获取当前路由ID 此ID是科目ID
    this.camp_id = this.$route.params.id;
    sessionStorage.setItem("router", this.$route.params.id);
    // if (this.agency_id != null) {
    this.getCamp(this.camp_id);
    // }
    this.logSwapr();
  },
};
</script>

<style lang="less" scoped>
.router {
  margin-top: 1.1875rem;
  height: auto;
  width: 100%;
  // 把整个图片分成了上下两部分。
  // top为上半部分，为图片以及课程内容部分
  .card_top {
    // transform: translateY(30px);
    // 上半部分的图片部分
    width: 100%;
    height: 20.8125rem;
    display: flex;
    flex-direction: row;
    .card_img {
      width: 28.1875rem;
      height: 20.8125rem;
      border-radius: 0.3125rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 上半部分的右侧文字部分
    .card_text_box {
      flex: 1;
      margin-left: 3.25rem;
      width: 39.375rem;
      height: 100%;

      // 右侧标题
      .card_title {
        font-size: 1.75rem;
        font-family: " Microsoft YaHei";
        font-weight: bold;
        color: #333333;
        line-height: 1.625rem;
        cursor: pointer;
      }
      // 右侧描述
      .card_content_box {
        margin-top: 1.625rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        .card_content {
          font-size: 1.125rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #585858;
        }
      }

      // 右侧时间等信息
      .card_info {
        display: flex;
        flex-direction: row;
        margin-top: 2.4375rem;
        width: 100%;
        height: 7.5rem;
        margin-top: 2.4375rem;
        .card_info_left {
          width: 24.875rem;
          height: 100%;
        }
        .card_info_font {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #585858;
          line-height: 1.75rem;
        }
      }
      // 右侧报名按钮
      .apply {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: 4.5625rem;
        display: flex;
        // flex-direction: column;
        align-items: center;
        padding-left: 1rem;
        background-color: #424c5b;
        border-radius: 0.4375rem;
        .fontSize20 {
          font-size: 1.25rem;
        }
        .apply_font {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #ffffff;
          line-height: 1.6875rem;
        }
        .applyBtn {
          position: absolute;
          right: 0;
          top: 0;
          width: 13.8125rem;
          height: 4.5625rem;
          background: linear-gradient(144deg, #ff5a25, #ff7d3a);
          border-radius: 0.4375rem;
          .applyBtn_now {
            font-size: 1.625rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            line-height: 4.5625rem;
            text-align: center;
          }
        }
        .applyBtn:hover {
          background: linear-gradient(144deg, #ff7d3a, #ff5a25);
        }
      }
    }
  }
  // 下半部分盒子
  .card_bottom {
    overflow: hidden;
    margin-top: 2.875rem;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 3.8125rem;
    background: #f7f0e7;
    border: 0.3125rem solid #fffcf6;
    border-radius: 0.375rem;
    .card_bottom_left,
    .card_bottom_right {
      height: 100%;
      flex: 1;
      text-align: center;
      position: relative;
      .zore {
        padding: 0px 20px;
        position: absolute;
        top: 0;
        width: 100%;
      }
    }
    .card_bottom_center {
      width: 0.125rem;
      height: 1.875rem;
      background: #e8dbcb;
    }
    .card_bottom_right {
      flex: 1;
      text-align: center;
    }
    .card_bottom_a {
      display: flex;
      justify-content: center;
      align-items: center;
      // display: block;
      width: 100%;
      height: 3.2125rem;
      font-size: 0.875rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #524546;
    }
  }
}

// .lunbo-enter-active,
// .lunbo-leave-active {
//   a {
//     div {
//       transition: transform 0.5s;
//       transform: translateY(15px);
//     }
//   }
// }
// .lunbo-enter,
// .lunbo-leave-active {
//   transform: translateY(15px);
// }

.lunbo-icon-enter-active {
  transition: opacity 0.5s;
}
.lunbo-icon-enter {
  opacity: 0;
}
.lunbo-icon-leave-active {
  transition: opacity 0.5s;
}
.lunbo-icon-leave-to {
  opacity: 0;
}
</style>